import React, { useCallback, useContext, useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import appstoreBadge from "../../../../assets/media/app-store-badge.png";
import playstoreBadge from "../../../../assets/media/google-play-badge.png";
import Container from "../../../../components/structure/Container";
import Flex from "../../../../components/structure/Flex";
import { FullPageLoading } from "../../../../components/ui/Loading"; // Import loader component
import { Login } from "../../../../components/ui/Login";
import { AuthContext } from "../../../../contexts/auth";
import DeleteAccount from "../UserDashboard/components/Dashboard/components/DeleteAccount";

const UserSignIn: React.FC = () => {
  const history = useHistory();
  const { isLoggedIn } = useContext(AuthContext);
  const [modalVisible, setModalVisible] = useState<boolean>(false);

  useEffect(() => {
    if (isLoggedIn) {
      history.replace("/dashboard");
    }
  }, [isLoggedIn, history]);

  const goBack = useCallback(() => {
    history.goBack();
  }, [history]);

  const toggleModal = useCallback(() => {
    setModalVisible((prev) => !prev);
  }, []);

  const renderLoginPage = () => (
    <div>
      <header className="flex flex-col px-4 py-8 bg-accent">
        <Flex items="center" className="px-2 mb-2 sm:px-0">
          <button onClick={goBack} className="mt-1 mr-4" aria-label="Go Back">
            <i className="text-2xl material-icons">arrow_back</i>
          </button>
          <div className="flex flex-col items-center w-full max-w-xl mx-auto">
            <span className="text-lg font-medium">Live It. Now</span>
            <h1 className="text-3xl font-medium text-orange">Login</h1>
          </div>
        </Flex>
      </header>

      {/* Login Form */}
      <Login />

      <section className="bg-gray-200">
        <Container className="md:relative">
          <Flex className="pt-24 pb-20 md:pt-20 md:pb-36">
            <div className="px-10 md:px-0">
              <h1 className="text-3xl font-medium text-dark">
                Zostel, now even <br />
                closer to you.
              </h1>
              <Flex
                className="justify-between w-full my-8 md:justify-center"
                items="center"
              >
                {/* App Store Badge */}
                <a
                  href="https://apps.apple.com/us/app/zostel/id1620655522"
                  aria-label="Download on the App Store"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img
                    src={appstoreBadge}
                    alt="Download on the App Store"
                    className="object-contain my-3 mr-4 md:w-48 md:h-14 md:mx-2 md:my-0"
                  />
                </a>

                {/* Google Play Badge */}
                <a
                  href="https://play.google.com/store/apps/details?id=com.zostel.app.android"
                  aria-label="Get it on Google Play"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img
                    src={playstoreBadge}
                    alt="Get it on Google Play"
                    className="object-contain my-3 ml-4 md:w-48 md:h-14 md:mx-2 md:my-0"
                  />
                </a>
              </Flex>
            </div>
          </Flex>

          {/* Promotional Banner Image */}
          <img
            src="https://zo-media.s3.ap-south-1.amazonaws.com/branding/app/screenshots/app_page_banner.webp"
            className="absolute bottom-0 right-0 hidden w-1/3 px-10 mr-40 overflow-visible md:block"
            alt="App page banner"
          />
        </Container>
      </section>

      {/* Delete Account Modal */}
      {modalVisible && <DeleteAccount toggleModal={toggleModal} />}
    </div>
  );

  return (
    <>
      {!isLoggedIn && isLoggedIn !== null ? (
        renderLoginPage()
      ) : (
        <FullPageLoading />
      )}
    </>
  );
};

export default React.memo(UserSignIn);
